import { defaultSite, Model, models, SiteConfig } from './models';

export const ivanildoSlug = 'ivanildoeletricista';
export const ivanildoMaps = 'https://maps.app.goo.gl/ciXHgnG2qMh5eKdy5';
export const ivanildoReviewSource = 'https://www.locaisdobrasil.com.br/encontre/eletricista/sao-paulo-sp/ivanildo-eletricista-vila-mariana-santa-cruz-mirandopolis/66c7a7b0f99178ff57474216';
export const ivanildoSite = defaultSite('eletricista', {
  name: 'Ivanildo Eletricista', phone: '5511986228374', color: '#ae3428',
  region: 'Vila Mariana · Santa Cruz · Mirandópolis', mapsUrl: ivanildoMaps,
});

// Match the verified contact, not the name: there are other electricians named Ivanildo.
export function isIvanildoSite(site: Partial<SiteConfig>): boolean {
  const digits = site.phone?.replace(/\D/g, '') || '';
  return site.segment === 'eletricista' && ['5511986228374', '11986228374'].includes(digits);
}

export const ivanildoModel: Model = {
  ...models.eletricista,
  intro: 'Precisa de um eletricista? Fale diretamente comigo para instalações, manutenção e reparos. Envie o que precisa e seu bairro pelo WhatsApp para combinarmos o atendimento.',
  action: 'Falar com Ivanildo',
  services: [
    { icon: 'Plug', title: 'Tomadas e interruptores', text: 'Precisa instalar ou trocar um ponto elétrico? Me conte o que precisa para avaliarmos a instalação.' },
    { icon: 'Lightbulb', title: 'Iluminação', text: 'Instalações elétricas para iluminar os ambientes. Envie uma foto e converse comigo sobre o serviço.' },
    { icon: 'Zap', title: 'Quadros e disjuntores', text: 'Seu disjuntor está desarmando? Descreva o que acontece para combinarmos a avaliação do problema.' },
    { icon: 'Wrench', title: 'Manutenção e reparos', text: 'Falhas na instalação ou um ponto que parou de funcionar? Vamos entender o que precisa ser verificado.' },
    { icon: 'Droplets', title: 'Chuveiros elétricos', text: 'Instalação, troca e avaliação de problemas elétricos do chuveiro. Consulte as condições para o seu equipamento.' },
    { icon: 'House', title: 'Instalações elétricas', text: 'Instalações elétricas em geral. Conte sobre seu imóvel ou sua reforma para combinarmos o escopo do serviço.' },
  ],
  faq: [
    ['Quais regiões você atende?', 'Minha referência de atendimento é a Vila Mariana, Santa Cruz e Mirandópolis, em São Paulo. Me envie seu bairro pelo WhatsApp para confirmar a disponibilidade para seu endereço.'],
    ['Como pedir um orçamento?', 'Me envie uma descrição do que precisa, seu bairro e, se possível, fotos. Com essas informações, combinamos a avaliação, o escopo e os valores antes do serviço.'],
    ['Você atende emergências?', 'Consulte a disponibilidade pelo WhatsApp ou por telefone. O atendimento e o horário precisam ser confirmados comigo; não há promessa de atendimento imediato ou 24 horas.'],
    ['Posso mandar fotos do problema?', 'Sim. Fotos ajudam na conversa inicial, mas a avaliação presencial pode ser necessária. Não abra quadros nem toque em fios para fotografar.'],
  ],
};

// 23 quoted words total; no invented names, dates or review counts.
export const ivanildoReviews = [
  'Atendimento, profissional competente e sério, recomendo 100%..',
  'Ótimo profissional, trocou meu chuveiro bem rápido',
  'Serviço rápido, pontual e eficiente. Recomendo!',
];
